/* eslint-disable react/no-unused-prop-types */
/* istanbul ignore file */

import React, { forwardRef, memo } from 'react';
import type { TextInput } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { theme } from '@garnish/constants';

import { LocationSearchField } from '../LocationSearchField';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationSearchFieldForSearchType = memo(
  forwardRef<TextInput, LocationSearchFieldForSearchTypeProps>((props, ref) => {
    const {
      searchString,
      deliverySearchString,
      isLoadingLocations,
      locationSearchType,
      onLocationSearchStringSubmit,
      onDeliverySearchStringChange,
    } = props;

    // ─── Delivery ────────────────────────────────────────────────────────

    if (locationSearchType === 'delivery') {
      return (
        <View style={styles.container}>
          <LocationSearchField
            ref={ref}
            value={deliverySearchString}
            isDisabled={isLoadingLocations}
            onChangeText={onDeliverySearchStringChange}
          />
        </View>
      );
    }

    // ─── Pickup | Outpost ────────────────────────────────────────────────

    return (
      <View style={styles.container}>
        <LocationSearchField
          ref={ref}
          value={searchString}
          isDisabled={isLoadingLocations}
          onSubmit={onLocationSearchStringSubmit}
        />
      </View>
    );
  }),
);

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spacing.medium,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LocationSearchFieldForSearchTypeProps = {
  readonly searchString: string;
  readonly deliverySearchString: string;
  readonly locationSearchType: string;
  readonly isLoadingLocations: boolean;
  readonly onLocationSearchStringSubmit: (searchString: string) => void;
  readonly onDeliverySearchStringChange: (searchString: string) => void;
};
